<template lang="pug">
    div.container-cadastro
      div#passos
        el-steps(:active="passoAtivo" finish-status="success" simple)
          el-step(title="Confirmar Ofício de Matrícula")
          el-step(title="Confirmar Portaria")
      div#corpo
        div(v-if="passoAtivo === 0 && matriculaBytes")
            app-pdf-viewer(:bytes="matriculaBytes")

        div(v-if="passoAtivo === 1 && portariaBytes")
            app-pdf-viewer(:bytes="portariaBytes")

      app-buttons-cadastro(
        :isPrimeiroPasso="false",
        :isUltimoPasso="ultimoPasso",
        :showButtonCancelar="false",
        :showButtonSalvar="false",
        :showButtonDownload="true"
        :showButtonProximo="!ultimoPasso"
        @proximo="proximo",
        @finalizar="finalizar",
        @voltar="voltar",
        @download="download"
      )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformarDados from '@/screens/arrecadacao/cpat/components/matricula/InformarDados'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'
import FileHelper from '@/utils/fileHelper'
import { mapActions } from 'vuex'
import AppPdfViewer from '@/components/AppPDFViewer'

export default {
  components: {
    InformarDados,
    AppButtonsCadastro,
    AppPdfViewer
  },

  mixins: [AppNotificacao, BaseAnaliseProcessos],

  props: {
    oficios: {
      type: Object,
      required: true
    }
  },

  async created () {
    if (this.oficios) {
      this.matriculaBytes = await this.getPDFMatricula(
        this.oficios.matricula.id
      )
      this.portariaBytes = await this.emitirPortaria(
        this.oficios.portaria.processo.id
      )
    }
  },

  data () {
    return {
      passoAtivo: 0,
      portariaBytes: null,
      matriculaBytes: null
    }
  },

  computed: {
    ultimoPasso () {
      return this.passoAtivo === 1
    },
    bytes () {
      return this.passoAtivo === 0 ? this.matriculaBytes : this.portariaBytes
    },
    nomeDocumentoAtual () {
      return this.passoAtivo === 0
        ? this.oficios.matricula.nome
        : `portaria_${this.oficios.portaria.numeroPortaria}`
    }
  },

  watch: {
    oficios: {
      deep: true,
      async handler (val, oldVal) {
        if (Object.keys(val).length && oldVal !== val) {
          this.matriculaBytes = await this.getPDFMatricula(
            this.oficios.matricula.id
          )
          this.portariaBytes = await this.emitirPortaria(
            this.oficios.portaria.processo.id
          )
        }
      }
    }
  },

  methods: {
    ...mapActions({
      finalizarMatricula: 'oficioArrecadacao/tramitarMatricula',
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula',
      emitirPortaria: 'portariaArrecadacao/emitirPortaria'
    }),

    async proximo () {
      this.passoAtivo = this.passoAtivo + 1
    },

    finalizar () {
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        () => {
          this.finalizarMatricula(this.oficios.matricula.id)
            .then(response => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                response
              )
              this.goToListagem('cpat/oficios', {
                idProcesso: this.oficios.matricula.processo.id
              })
            })
            .catch(error => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    download () {
      FileHelper.saveFile(this.bytes, this.nomeDocumentoAtual)
    },

    voltar () {
      this.passoAtivo = this.passoAtivo - 1
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/matricula/EnvioCartorio.vue